module.exports = __webpack_public_path__ + "img/loading.e1d70bd2.gif";